import { CallbackSuccessHandler, FetchResult, useFetchCallback } from 'json-api-hooks';
import React from 'react';
import { useForm } from 'react-hook-form';

import useSnackbar from '../../../hooks/useSnackbar';
import Form from '../../Form/Form';
import parseErrors from '../../Form/lib/parseErrors';
import { FormFieldDefinition } from '../../Form/ResourceForm';
import { InputType } from '../../Form/types';
import Heading from '../../Heading';

const fields: FormFieldDefinition[] = [
  {
    type: InputType.Email,
    label: 'Email',
    required: true,
    attribute: 'email',
  },
  {
    type: InputType.Text,
    label: 'Voornaam',
    required: true,
    attribute: 'first_name',
  },
  {
    type: InputType.Text,
    label: 'Achternaam',
    required: true,
    attribute: 'last_name',
  },
  {
    type: InputType.Text,
    label: 'Postcode',
    required: true,
    attribute: 'postal_code',
  },
  {
    type: InputType.Telephone,
    label: 'Telefoon',
    required: true,
    attribute: 'telephone',
  },
  {
    type: InputType.Password,
    label: 'Wachtwoord',
    required: true,
    attribute: 'password',
    placeholder: '*********',
  },
  {
    type: InputType.Password,
    label: 'Bevestig wachtwoord',
    required: true,
    attribute: 'password_confirmation',
    placeholder: '*********',
  },
  {
    type: InputType.Description,
    attribute: 'disclaimer',
    description:
      'Door je te registreren kan je lokale campagneleider af en toe contact met je opnemen over toekomstige activiteiten. Daarnaast sturen we je soms een mail over de campagne, tenzij je eerder hebt aangegeven geen mails te willen ontvangen. Hiervoor kun je jezelf altijd uitschrijven.',
  },
];

const SignUpForm = ({ redirectUrl }: { redirectUrl?: string }) => {
  const methods = useForm();
  const showSnackbar = useSnackbar();
  const [callback, loading] = useFetchCallback('/u', 'POST');

  const handleError = ({ json }: FetchResult) => parseErrors(json, fields, methods.setError);

  const handleSuccess: CallbackSuccessHandler = () => {
    showSnackbar('Het account is aangemaakt.');

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.reload();
    }
  };

  const onSubmit = methods.handleSubmit((data) => {
    callback({ user: data }).then(handleSuccess).catch(handleError);
  });

  return (
    <>
      <Heading>Account aanmaken</Heading>
      <Form fields={fields} loading={loading} methods={methods} submitLabel="Bevestigen" onSubmit={onSubmit} />
    </>
  );
};

export default SignUpForm;
